export const CommonColumnProps = {
  editable: false,
  sortable: false,
  disableColumnMenu: true,
  minWidth: 230,
  flex: 1,
}
